<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">

                                <mat-tab-group mat-align-tabs="start" #tabGroup
                  >
                  <mat-tab label="Informations">

                    <div class="row" style="padding: 10px;">
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                        style="padding-left: 5px; padding-right: 5px;position:relative">
                        <label (click)="onPenDetailModal('','garant')"
                            [ngClass]="{'isSelectedItem':itemToSave.garant_id}">Garant :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="on_change_garant()" [(ngModel)]="itemToSave.garant_id"
                            placeholder="Choisissez " name="garant_id" id="garant_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsGarant" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalGarantComponent()"><i
                                class="fa fa-plus"></i></button>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position:relative;">
                        <label (click)="onPenDetailModal('','souscripteur')"
                            [ngClass]="{'isSelectedItem':itemToSave.souscripteur_id}">Souscripteur :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.souscripteur_id" placeholder="Choisissez "
                            name="souscripteur_id" id="souscripteur_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsSouscripteur" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalSouscripteurComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                        <label>Date éffet :
                            <span class="required_champs">*</span>
                        </label>
                        <!-- <input
                                            onkeydown="return false" -->
                        <input type="text" placeholder="Date éffet" autocomplete="off" class="form-control" bsDatepicker
                            [bsConfig]="{
                                              dateInputFormat: 'DD/MM/YYYY',
                                              containerClass: 'theme-dark-blue'
                                            }" [(ngModel)]="itemToSave.date_effet" name="date_effet" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1">
                        <label>Date échéance :
                            <span class="required_champs">*</span>
                        </label>
                        <!-- <input
                                            onkeydown="return false" -->
                        <input type="text" placeholder="Date échéance" autocomplete="off" class="form-control"
                            bsDatepicker [bsConfig]="{
                                              dateInputFormat: 'DD/MM/YYYY',
                                              containerClass: 'theme-dark-blue'
                                            }" [(ngModel)]="itemToSave.date_echeance" name="date_echeance" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Plafond :
                            <span class="required_champs">*</span>
                        </label>
                        <input mask="separator" class="form-control custom-input" placeholder="Plafond"
                            autocomplete="off" [(ngModel)]="itemToSave.plafond" name="plafond" autocomplete="off"
                            type="text" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Catégorie :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.categorie_police_id" placeholder="Choisissez "
                            name="categorie_police_id" id="categorie_police_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsCategoriePolice" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                    </div>



                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Type remboursement :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select (change)="onSelectTypeRemboursement()" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.type_remboursement_id" placeholder="Choisissez "
                            name="type_remboursement_id" id="type_remboursement_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsTypeRemboursement" [value]="item.id">{{ item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Taux tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Taux tpg"
                            autocomplete="off" [(ngModel)]="itemToSave.taux_tpg" name="taux_tpg" autocomplete="off"
                            type="text" mask="separator" />

                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Majoration tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Majoration tpg"
                            autocomplete="off" [(ngModel)]="itemToSave.majoration_tpg" name="majoration_tpg"
                            autocomplete="off" type="text" mask="separator" />

                    </div>
                    <div *ngIf="is_tpg" class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Plafond tpg (%) :
                            <span class="required_champs">*</span>
                        </label>

                        <input [disabled]="isDetailMode" class="form-control custom-input" placeholder="Plafond tpg"
                            autocomplete="off" [(ngModel)]="itemToSave.plafond_tpg" name="plafond_tpg"
                            autocomplete="off" type="text" mask="separator" />

                    </div>

                                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Libellé :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Libellé" autocomplete="off"
                            [(ngModel)]="itemToSave.libelle" name="libelle" autocomplete="off" type="text" />
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px;position: relative;">
                        <label>Souscripteur :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.souscripteur_id" placeholder="Choisissez "
                            name="souscripteur_id" id="souscripteur_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsSouscripteur" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                        <button disabled class="btn btn-success btn-quick-add" (click)="openModalAddSouscripteur()"><i
                            class="fa fa-plus"></i></button>
                    </div> -->


                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Code:
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" [disabled]="itemToSave.id" placeholder="Code"
                            autocomplete="off" [(ngModel)]="itemToSave.code" name="code" autocomplete="off"
                            type="text" />
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Codification:
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Codification" autocomplete="off"
                            [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off" type="text" />
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Numéro interne:
                        </label>
                        <input class="form-control custom-input" placeholder="Numéro interne" autocomplete="off"
                            [(ngModel)]="itemToSave.numero_interne" name="numero_interne" autocomplete="off"
                            type="text" />
                    </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Numéro externe:
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Numéro externe" autocomplete="off"
                            [(ngModel)]="itemToSave.numero_externe" name="numero_externe" autocomplete="off"
                            type="text" />
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux de couverture :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Taux de couverture" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_couverture" name="taux_couverture" autocomplete="off" type="text" mask="separator" />
                    </div> -->



                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission sinistre :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.forfait_commission_sinistre >0" mask="separator"
                            class="form-control custom-input" placeholder="Taux commission sinistre" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_sinistre" name="taux_commission_sinistre"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission sinistre :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.taux_commission_sinistre>0" mask="separator"
                            class="form-control custom-input" placeholder="Forfait commission sinsitre"
                            autocomplete="off" [(ngModel)]="itemToSave.forfait_commission_sinistre"
                            name="forfait_commission_sinistre" autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission prime :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.forfait_commission_prime>0" mask="separator"
                            class="form-control custom-input" placeholder="Taux commission prime" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_prime" name="taux_commission_prime"
                            autocomplete="off" type="text" />
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission prime :
                            <span class="required_champs">*</span>
                        </label>
                        <input [disabled]="itemToSave.taux_commission_prime>0" mask="separator"
                            class="form-control custom-input" placeholder="Forfait commission prime" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_prime" name="forfait_commission_prime"
                            autocomplete="off" type="text" />
                    </div> -->

                    
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position: relative;">
                        <label (click)="onPenDetailModal('','courtier')"
                            [ngClass]="{'isSelectedItem':itemToSave.courtier_id}">Courtier :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.courtier_id" placeholder="Choisissez " name="courtier_id"
                            id="courtier_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsCourtier" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCourtierComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission courtier(%) :
                        </label>
                        <input mask="000" (input)="itemToSave.taux_commission_courtier=''"
                            class="form-control custom-input" placeholder="Taux commission courtier" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_courtier" name="taux_commission_courtier"
                            autocomplete="off" type="text">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission courtier(%) :
                        </label>
                        <input (input)="itemToSave.forfait_commission_courtier=''" class="form-control custom-input"
                            placeholder="Forfait commission courtier" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_courtier" name="forfait_commission_courtier"
                            autocomplete="off" type="text" mask="separator">
                    </div> -->
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position: relative;">
                        <label (click)="onPenDetailModal('','intermediaire')"
                            [ngClass]="{'isSelectedItem':itemToSave.intermediaire_id}">Intermédiaire :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.intermediaire_id" placeholder="Choisissez "
                            name="intermediaire_id" id="intermediaire_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsIntermediaire" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCourtierComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission intermédiaire(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input mask="000" (input)="itemToSave.taux_commission_intermediaire=''"
                            class="form-control custom-input" placeholder="Taux commission intermédiaire"
                            autocomplete="off" [(ngModel)]="itemToSave.taux_commission_intermediaire"
                            name="taux_commission_intermediaire" autocomplete="off" type="text">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission intermédiaire(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input (input)="itemToSave.forfait_commission_intermediaire=''"
                            class="form-control custom-input" placeholder="Forfait commission intermediaire"
                            autocomplete="off" [(ngModel)]="itemToSave.forfait_commission_intermediaire"
                            name="forfait_commission_intermediaire" autocomplete="off" type="text" mask="separator">
                    </div>
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position: relative;">
                        <label (click)="onPenDetailModal('','apporteur')"
                            [ngClass]="{'isSelectedItem':itemToSave.apporteur_id}">Apporteur :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.apporteur_id" placeholder="Choisissez " name="apporteur_id"
                            id="apporteur_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsApporteur" [value]="item.id">{{ item.libelle ||
                                item.nom+' '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCourtierComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission apporteur (%) :
                        </label>
                        <input mask="000" (input)="itemToSave.taux_commission_apporteur=''"
                            class="form-control custom-input" placeholder="Taux commission apporteur" autocomplete="off"
                            [(ngModel)]="itemToSave.taux_commission_apporteur" name="taux_commission_apporteur"
                            autocomplete="off" type="text">
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission apporteur(%) :
                        </label>
                        <input (input)="itemToSave.forfait_commission_apporteur=''" class="form-control custom-input"
                            placeholder="Forfait commission apporteur" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_apporteur" name="forfait_commission_apporteur"
                            autocomplete="off" type="text" mask="separator">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container" style="position:relative">
                        <label (click)="onPenDetailModal('','commercial')"
                            [ngClass]="{'isSelectedItem':itemToSave.commerciale_id}">Commercial :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.commerciale_id" placeholder="Choisissez "
                            name="commerciale_id" id="commerciale_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsCommercial" [value]="item.id">{{ item.nom+'
                                '+item.prenom }}
                            </ng-option>
                        </ng-select>
                        <button class="btn btn-success btn-quick-add" (click)="openModalCommercialComponent()"><i
                                class="fa fa-plus"></i></button>

                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Taux commission commercial(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input mask="000" (input)="itemToSave.forfait_commission_commercial=''"
                            class="form-control custom-input" placeholder="Taux commission commercial"
                            autocomplete="off" [(ngModel)]="itemToSave.taux_commission_commercial"
                            name="taux_commission_commercial" autocomplete="off" type="text">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Forfait commission commercial(%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input (input)="itemToSave.taux_commission_commercial_id=''" class="form-control custom-input"
                            placeholder="Forfait commission commercial" autocomplete="off"
                            [(ngModel)]="itemToSave.forfait_commission_commercial" name="forfait_commission_commercial"
                            autocomplete="off" type="text" mask="separator">
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Délai de carence (jours) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Délai de carence" autocomplete="off"
                            [(ngModel)]="itemToSave.delai_carence" name="delai_carence" autocomplete="off" type="text"
                            mask="separator">
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil alerte consommation (%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil alerte conso" autocomplete="off"
                            [(ngModel)]="itemToSave.seuil_alerte_conso" name="seuil_alerte_conso" autocomplete="off"
                            type="text" />
                    </div>



                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Seuil suspension tiers payant (%) :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <input class="form-control custom-input" placeholder="Seuil suspension tp" autocomplete="off"
                            [(ngModel)]="itemToSave.seuil_suspension_tiers_payant" name="seuil_suspension_tiers_payant"
                            autocomplete="off" type="text" />
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>A qui rembourser? :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.assure_remboursement" placeholder="Choisissez "
                            name="assure_remboursement" id="assure_remboursement" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsRemboursement" [value]="item.code">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode tarification :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                            name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode reconduction :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.mode_reconduction_id" placeholder="Choisissez "
                            name="mode_reconduction_id" id="mode_reconduction_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeReconduction" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode fractionnement :
                        </label>
                        <ng-select [(ngModel)]="itemToSave.mode_fractionnement_id" placeholder="Choisissez "
                            name="mode_fractionnement_id" id="mode_fractionnement_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeFractionnement" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label (click)="openModalPrestataireReseau()"
                            [ngClass]="{'isSelectedItem':itemToSave.reseau_de_soin_id}">Réseau de soin :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.reseau_de_soin_id" placeholder="Choisissez "
                            name="reseau_de_soin_id" id="reseau_de_soin_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsReseauDeSoin" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Tarif :
                            <!-- <span class="required_champs">*</span> -->
                        </label>
                        <ng-select [(ngModel)]="itemToSave.tarif_id" placeholder="Choisissez " name="tarif_id"
                            id="tarif_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsTarif" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>



                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Statut :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.statut_police_id" placeholder="Choisissez "
                            name="statut_police_id" id="statut_police_id" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsStatutPolice" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Mode gestion avenant :
                        </label>
                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.mode_gest_avenant" placeholder="Choisissez "
                            name="mode_gest_avenant" id="mode_gest_avenant" [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsListeModeGestAvenant" [value]="item.value">{{
                                item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div> -->
                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1 select-container">
                        <label>Périodicité avenant :
                        </label>
                        <ng-select [clearable]="false" [disabled]="isDetailMode"
                            [(ngModel)]="itemToSave.periodicite_avenant" placeholder="Choisissez "
                            name="periodicite_avenant" id="periodicite_avenant" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsPeriodiciteAvenant" [value]="item.value">{{ item.libelle
                                }}
                            </ng-option>
                        </ng-select>
                    </div> -->

                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_prorata_prime" id="is_prorata_prime" name="is_prorata_prime"
                            autocomplete="off" type="checkbox" />
                        <label for="is_prorata_prime">Prorata prime?
                        </label>
                        <ng-select *ngIf="itemToSave.is_prorata_prime" [(ngModel)]="itemToSave.mode_prorata_id"
                            placeholder="Choisissez mode prorata " name="mode_prorata_id" id="statut_garant_id"
                            [multiple]="false" [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsModeProrata" [value]="item.id">{{ item.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_attente_prealable_acte_visible"
                            id="is_attente_prealable_acte_visible" name="is_attente_prealable_acte_visible"
                            autocomplete="off" type="checkbox" />
                        <label for="is_attente_prealable_acte_visible">Acte entente préalable visible?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_non_garantie_acte_visible" id="is_non_garantie_acte_visible"
                            name="is_non_garantie_acte_visible" autocomplete="off" type="checkbox" />
                        <label for="is_non_garantie_acte_visible">Actes non garantis visibles?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_attente_prealable_medoc_visible"
                            id="is_attente_prealable_medoc_visible" name="is_attente_prealable_medoc_visible"
                            autocomplete="off" type="checkbox" />
                        <label for="is_attente_prealable_medoc_visible">Médoc entente préalable visible?
                        </label>


                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <input [(ngModel)]="itemToSave.is_non_garantie_medoc_visible" id="is_non_garantie_medoc_visible"
                            name="is_non_garantie_medoc_visible" autocomplete="off" type="checkbox" />
                        <label for="is_non_garantie_medoc_visible">Médoc non garantie visible?
                        </label>


                    </div> -->



                </div>
                   
                  </mat-tab>
                  <mat-tab label="Données de facturation">
                    <div class="container-fluid">

                                <h5 style="text-align:center">Facture caution garantie</h5>

                                <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Fraction caution démarrage (Nbr/12):
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="Une fraction (très souvent 2/12) des sinistres de l'exercice passé.
Nb : quand il s’agit d’un démarrage, les sinistres sont estimés (provision de sinistre). On applique 2/12 pour avoir la caution de démarrage.
" class="form-control custom-input" placeholder="Fraction caution" autocomplete="off"
                                            [(ngModel)]="itemToSave.fraction_caution" name="fraction_caution"
                                            autocomplete="off" type="text" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Source fond caution permanente :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <ng-select title="Le montant que le garant dépose comme garantie au gestionnaire. Ce montant peut provenir n/12ieme des sinistres provisionnés ou un forfait.
" [(ngModel)]="itemToSave.source_fond_caution_permanente" placeholder="Choisissez "
                                            name="source_fond_caution_permanente" id="source_fond_caution_permanente"
                                            [multiple]="false" [closeOnSelect]="true"
                                            (change)="onChangeSourceFondCaution()">
                                            <ng-option *ngFor="let item of itemsSourceFondCaution"
                                                [value]="item.code">{{ item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1" *ngIf="itemToSave.source_fond_caution_permanente!=='FORFAIT'" 
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Assiette fond caution garantie :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <ng-select 
                                            title="Que la source des fonds de caution permanente soit forfait ou provision de sinistre, il faut indiquer l’assiette de fond (par garant, par famille ou par bénéficiaire) "
                                            [disabled]="isDetailMode" [(ngModel)]="itemToSave.assiete_fond_caution_permanente"
                                            placeholder="Choisissez " name="assiete_fond_caution_permanente"
                                            id="assiete_fond_caution_permanente" [multiple]="false"
                                            [closeOnSelect]="true" (change)="onChangeAssieteCaution()">
                                            <ng-option *ngFor="let item of assietteDeFond" [value]="item.code">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div *ngIf="itemToSave.source_fond_caution_permanente=='FORFAIT'"
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Forfait caution permanente :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="La caution permanente sous forme de forfait"
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Forfait caution permanente" autocomplete="off"
                                            [(ngModel)]="itemToSave.forfait_caution_permanente"
                                            name="forfait_caution_permanente" autocomplete="off" type="text"
                                            mask="separator" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Seuil complément caution (%):
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="Soit n le seuil pour complément de caution, k la fraction de caution, s le cumul des sinistres de l’année écoulée et c la caution actuelle.
    • La nouvelle caution est C2 = k/12ieme * s
    • L’ancienne caution est C
    •  Δc = C2-C
Si Δ > n*C/100, une facture complémentaire de Δc est adressée au garant.
En d’autres termes :
Si la variation de la caution est supérieure de n/100 la caution passée, une facture complémentaire est adressée au garant pour réclamer ce montant (nouvelle caution – ancienne caution)
" class="form-control custom-input" placeholder="Seuil complément caution" autocomplete="off"
                                            [(ngModel)]="itemToSave.seuil_complement_caution"
                                            name="seuil_complement_caution" autocomplete="off" type="text" />
                                    </div>

                                </div>
                                <hr>
                                <h5 style="text-align:center">Facture sinistre</h5>
                                <div class="row">




                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Source fond sinistre :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>


                                        <ng-select title="Le remboursement des sinistres :
    • Provision sinistres (une estimation des sinistres qui est réclamé au garant en fonction la périodicité de facturation)
    • Sinistres réels (le gestionnaire MCI paie d’abord les sinistres et réclame par la suite au garant)
" [disabled]="isDetailMode" [(ngModel)]="itemToSave.source_fond_sinistre" placeholder="Choisissez "
                                            name="source_fond_sinistre" id="source_fond_sinistre" [multiple]="false"
                                            [closeOnSelect]="true" (change)="onChangeSourceFondSinistre()">
                                            <ng-option *ngFor="let item of itemsSourceFondSinistre"
                                                [value]="item.code">{{ item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Assiète fond sinistre :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>


                                        <ng-select title="La base de calcul de la source de fond :
    • Par garant (nombre =1)
    • Par famille (nombre de famille)
    • Par bénéficiaire (nombre d’individus) " [disabled]="isDetailMode" [(ngModel)]="itemToSave.assiete_fond_sinistre"
                                            placeholder="Choisissez " name="assiete_fond_sinistre"
                                            id="assiete_fond_sinistre" [multiple]="false" [closeOnSelect]="true"
                                            (change)="onChangeAssieteSinistre()">
                                            <ng-option *ngFor="let item of assietteDeFond" [value]="item.code">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Périodicité fond sinistre :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <ng-select
                                            title="C’est la fréquence d’établissement de facturation des sinistre au garant"
                                            [(ngModel)]="itemToSave.periodicite_fond_sinistre" placeholder="Choisissez "
                                            name="periodicite_fond_sinistre" id="periodicite_fond_sinistre"
                                            [multiple]="false" [closeOnSelect]="true"
                                            (change)="onChangePeriodiciteFondSinistre()">
                                            <ng-option *ngFor="let item of periodicite" [value]="item.code">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    

                                    

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux commission provision sinistre (%) :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux commission provision sinistre" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_commission_prov_sinistre"
                                            name="taux_commission_prov_sinistre" autocomplete="off" type="text" mask="separator" />
                                    </div>

                                    </div>
                                    <hr>
                                    <h5 style="text-align: center;">Facture deficit</h5>
                                    <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Périodicité facturation déficit :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
        
                                        <ng-select
                                            title="En cas de provision de sinistres, quand il y a un déficit (sinistres réels supérieurs à la provision de sinistres) alors une facture complémentaire est adressée au garant pour réclamer la différence."
                                            [(ngModel)]="itemToSave.periodicite_deficit" placeholder="Choisissez "
                                            name="periodicite_deficit" id="periodicite_deficit" [multiple]="false"
                                            [closeOnSelect]="true" (change)="onChangePeriodiciteDeficit()">
                                            <ng-option *ngFor="let item of periodicite" [value]="item.code">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    </div>
                                    <hr>
                                    <h5 style="text-align: center;">Facture honoraire</h5>
                                    <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Source fond honoraire :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        

                                        <ng-select title="La rémunération du gestionnaire :
    • Prime
Il s’agit d’une commission sur les primes d’assurance
    • Provisions sinistres
Une commission (un taux) sur les sinistres provisionnées (par garant, famille ou bénéficiaire)
    • Forfait
Un montant forfaitaire est fixé comme honoraire (soit par garant, soit par famille, soit par tête)
    • Sinistres réels" [disabled]="isDetailMode" [(ngModel)]="itemToSave.source_fond_honoraire"
                                            placeholder="Choisissez " name="source_fond_honoraire"
                                            id="source_fond_honoraire" [multiple]="false" [closeOnSelect]="true"
                                            (change)="onChangeSourceFondHonoraire()">
                                            <ng-option *ngFor="let item of itemsSourceFondHonoraire"
                                                [value]="item.code">{{ item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div *ngIf="itemToSave.source_fond_honoraire == 'FORFAIT' "
                                        class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Forfait fond honoraire(HT) :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input
                                            title="Si choisit source de fond « forfait », il faut alors préciser le montant du forfait"
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Forfait fond honoraire" autocomplete="off"
                                            [(ngModel)]="itemToSave.forfait_fond_honoraire"
                                            name="forfait_fond_honoraire" autocomplete="off" type="text" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Assiète fond honoraire :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>

                                        <ng-select
                                            title="Si choisit source de fond « forfait » ou « provision de sinistre », il faut alors préciser l’assiette (garant ou famille ou bénéficiaire)"
                                            [disabled]="isDetailMode" [(ngModel)]="itemToSave.assiete_fond_honoraire"
                                            placeholder="Choisissez " name="assiete_fond_honoraire"
                                            id="assiete_fond_honoraire" [multiple]="false" [closeOnSelect]="true"
                                            (change)="onChangeAssieteHonoraire()">
                                            <ng-option *ngFor="let item of assietteDeFond" [value]="item.code">{{
                                                item?.libelle }}
                                            </ng-option>
                                        </ng-select>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                            style="padding-left: 5px; padding-right: 5px">
                                            <label>Périodicité fond honoraire :
                                                <!-- <span class="required_champs">*</span> -->
                                            </label>
                                            <ng-select
                                                title="C’est la fréquence d’établissement de factures d'honoraire au garant"
                                                [(ngModel)]="itemToSave.periodicite_fond_honoraire"
                                                placeholder="Choisissez " name="periodicite_fond_honoraire"
                                                id="periodicite_fond_honoraire" [multiple]="false"
                                                [closeOnSelect]="true" (change)="onChangePeriodiciteFondHonoraire()">
                                                <ng-option *ngFor="let item of periodicite" [value]="item.code">{{
                                                    item?.libelle }}
                                                </ng-option>
                                            </ng-select>
                                        </div>

                                        </div>
                                        <hr>
                                        <h5 style="text-align:center">Estimations && taux</h5>
                                        <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Estimation nombre de familles :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="Nombre total de famille toutes polices confondues du garant"
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Estimation nombre famille" autocomplete="off"
                                            [(ngModel)]="itemToSave.nombre_famille_estime" name="nombre_famille_estime"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Prime estimée par famille :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="La prime approximative par famille"
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Estimation prime par famille" autocomplete="off"
                                            [(ngModel)]="itemToSave.prime_par_famille_estime" name="prime_par_famille_estime"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Estimation nombre de bénéficiaires :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="Nombre total de bénéficiaires toutes polices confondues du garant
" [disabled]="isDetailMode" class="form-control custom-input" placeholder="Estimation nombre bénéficiaires"
                                            autocomplete="off" [(ngModel)]="itemToSave.nombre_beneficiaires_estime"
                                            name="nombre_beneficiaires_estime" autocomplete="off" type="text" mask="separator" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Prime estimée par bénéficiaire :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input title="La prime approximative par bénéficaire"
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Estimation prime par bénéficiaire" autocomplete="off"
                                            [(ngModel)]="itemToSave.prime_par_beneficiaire_estime" name="prime_par_beneficiaire_estime"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div>

                                    
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux tva (%) :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux tva" autocomplete="off" [(ngModel)]="itemToSave.taux_tva"
                                            name="taux_tva" autocomplete="off" type="text" mask="separator" />
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux commission primes (%) :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input
                                            title="Si l’on choisit de calculer les honoraires par prime, on renseigne le taux à appliquer à la prime."
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux commission prime" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_commission_prime" name="taux_commission_prime"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Montant provision garant :
                                            <!-- <span class="required_champs">*</span> -->
                                        </label>
                                        <input
                                            title="Si source de fond sinistre est provision sinistre et que assiete fond sinistre est garant, on renseigner le montant de la provision directement (pas de calcul basé sur nombre de bénéficiaires ou familles)"
                                            [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Montant provision garant" autocomplete="off"
                                            [(ngModel)]="itemToSave.montant_provision_garant"
                                            name="montant_provision_garant" autocomplete="off" type="text" />
                                    </div>
                                    
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                                        style="padding-left: 5px; padding-right: 5px">
                                        <label>Taux redressement:
                                            <span class="required_champs">*</span>
                                        </label>
                                        <input [disabled]="isDetailMode" class="form-control custom-input"
                                            placeholder="Taux redressement" autocomplete="off"
                                            [(ngModel)]="itemToSave.taux_redressement" name="taux_redressement"
                                            autocomplete="off" type="text" mask="separator" />
                                    </div> -->
                                </div>

                            </div>
                  </mat-tab>
                  
                </mat-tab-group>
                
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
            [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>